import { reduxForm } from 'redux-form'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'

import EditCover from './edit_cover'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    isAndroid:
      state.device_info.isMobile && state.device_info.deviceOS === 'Android',
    initialValues: {
      gradientColor: campaign.gradient_color,
      backgroundImage: campaign.background_image,
      backgroundImageFilename: campaign.background_image_filename,
      backgroundPan: campaign.background_pan,
    },
    campaignType: campaign.campaign_type,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, {
          gradient_color: formValues.gradientColor,
          background_image: formValues.backgroundImage || '',
          background_image_filename: formValues.backgroundImageFilename,
          background_pan: formValues.backgroundPan,
        })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'edit_cover',
    fields: [
      'gradientColor',
      'backgroundImage',
      'backgroundImageFilename',
      'backgroundPan',
    ],
  },
  mapStateToProps,
  mapDispatchToProps
)(EditCover)
